import axios from "axios";
import firebase from 'firebase'
import firebaseconfig from '../firebase/firebaseIndex'
import SalesCharts from '../Components-Sales/salesDashboard'

export function login(username, password){
    const authHeader = {
      "Content-type": "application/json",
    };
    var body = {
		    username: username,
        password: password
    };
    
    return firebase.auth().signInWithEmailAndPassword(username, password)
    
    .then(data => {
        return data;
      })
    .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(error);
        body = {
            "status": 401,
            "error": error
        }
        return body;
        // ...
      });
      
    /*return axios({
      method: "POST",
      headers: authHeader,
      url: "api/v1/auth/login",
      data: body
    })

    .then(data => {
      return data;
    })
        .catch(error => {
      return error.response;
    });*/
  }
